export default "__VITE_ASSET__DRse_xo5__"